import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";
import { useNavigate } from "react-router-dom";


const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const AlfListReport = () => {
  const [loading, setLoading] = useState(false);
  const [reportList, setReportList] = useState([]);

  const [filters, setFilters] = useState({
    municipality_id: "",
    district_id: "",
  });

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [districts, setDistricts] = useState([]);
  const [municipalityList, setMunicipalities] = useState([]);

  const navigate = useNavigate();

    const getAuthHeader = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });


   const loadDistricts = async () => {
    try {
      const res = await axios.post(`${BASE_URL}/districtMasterList`,
        {}, getAuthHeader());
      setDistricts(res.data?.data || []);
      setPage(res.data.page|| 1);
      setTotalPages(res.data.total_records || 0);
    } catch (err) {
      console.error("District load error:", err);

      if (err.response?.status === 401) {
        Swal.fire("Session Expired", "Please login again", "warning");
        localStorage.clear();
                localStorage.clear();

        navigate("/suda/login");
      } else if (err.response?.status === 422) {
        Swal.fire(
          "Validation Failed",
          err.response.data?.message || "Invalid request",
          "warning"
        );
      } else {
        Swal.fire("Alert!", "Failed to load districts", "error");
      }
    }
  };


 const fetchClfListReport = async (
  pageNo = 1,
  municipalityId = filters.municipality_id,
  districtId = filters.district_id
) => {
  try {
    setLoading(true);

    // ✅ THIS IS THE FIX
    setPage(pageNo);

    const payload = {
      district_id: districtId,
      municipality_id: municipalityId,
      page: pageNo,
      per_page: perPage,
    };

    const res = await axios.post(
      `${BASE_URL}/municipalityWiseCLFreport`,
      payload,
      getAuthHeader()
    );

    if (res.data.status) {
      setReportList(res.data.data || []);
      setTotalRecords(res.data.total_records || 0);
      setTotalPages(Math.ceil((res.data.total_records || 0) / perPage));
    } else {
      setReportList([]);
    }
  } catch (err) {
    if (err.response?.status === 401) handle401();
    else Swal.fire("Alert", "Failed to fetch CLF report", "error");
  } finally {
    setLoading(false);
  }
};



  const getPageNumbers = () => {
  const pages = [];
  const maxPagesToShow = 5;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + maxPagesToShow - 1);

  if (end - start < maxPagesToShow - 1) {
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};

  const loadMunicipalities = async (districtId = filters.district_id) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/municipalityList`,
      {
        district_id: districtId || "",
      },
      getAuthHeader()
    );

    setMunicipalities(res.data?.data || []);

  } catch (err) {

    if (err.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
              localStorage.clear();

      navigate("/suda/login");
    } else if (err.response?.status === 422) {
      Swal.fire(
        "Validation Failed",
        err.response.data?.message || "Invalid request",
        "warning"
      );
    } else {
      Swal.fire("Alert!", "Failed to load municipalities", "error");
    }
  }
};



  useEffect(() => {
    loadDistricts();
    loadMunicipalities();
  }, []);



useEffect(() => {
  fetchClfListReport(1, "", "");
}, []);



  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    backgroundColor: "#edf7fe",
    borderBottom: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
  };



  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>

       <Card
              className="mb-4 border-0"
              style={{
                background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
                borderRadius: "14px",
                boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
              }}
            >
              <div
                className="px-4 py-3 text-white rounded-top"
                style={{
                  background: "linear-gradient(90deg, #0D47A1, #1565C1)",
                }}
              >
                <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
                  <i className="fa-solid fa-filter"></i> ALF List Report
                </h5>
              </div>
              <Card.Body className="px-4 py-4">
                <Row className="align-items-center">


                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold text-dark">District</Form.Label>
                      <Form.Select
                        value={filters.district_id}
                        onChange={(e) => {
  const districtId = e.target.value;

  setFilters({
    ...filters,
    district_id: districtId,
    municipality_id: "",
  });

  loadMunicipalities(districtId);
}}


                        style={{
                          borderRadius: "10px",
                          border: "2px solid #1565C1",
                        }}
                      >
                        <option value="">Select District</option>
                        {districts.map((d) => (
                          <option value={d.id} key={d.id}>
                            {d.name || d.district_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                    <Col md={3}>
                          <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">
                              Municipality
                            </Form.Label>
                            <Form.Select
                              value={filters.municipality_id}
                              style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
                              onChange={(e) =>
                          setFilters({ ...filters, municipality_id: e.target.value })
                        }
                            >
                              <option value="">All Municipalities</option>
                              {municipalityList.map((m) => (
                                <option key={m.user_id} value={m.user_id}>
                                  {m.name}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Col>

                  <Col md={3}>
                                <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

          <Form.Select
           style={{
                          borderRadius: "10px",
                          border: "2px solid #1565C1",
                        }}
            value={perPage}
            onChange={(e) => {
  const value = Number(e.target.value);
  setPerPage(value);
  setPage(1);
}}


          >
            <option value={10}>10 Per Page</option>
                        <option value={25}>25 Per Page</option>
                        <option value={50}>50 Per Page</option>
                        <option value={100}>100 Per Page</option>
          </Form.Select>
          </Form.Group>
        </Col>


                  <Col md={4} className="d-flex gap-3 mt-3">
                    {/* SEARCH */}
                    <Button
                      className="w-50 fw-semibold text-white"
                      style={{
                        background: "#1565C1",
                        border: "none",
                        borderRadius: "10px",
                        transition: "0.3s",
                      }}
                      onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                      onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
onClick={() => {
    setPage(1);
    fetchClfListReport(1, filters.municipality_id, filters.district_id);
  }}
                    >
                      <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                    </Button>

                    {/* RESET */}
                    <Button
        className="w-50 fw-semibold text-white"
        style={{
          background: "#E53935",
          border: "none",
          borderRadius: "10px",
          transition: "0.3s",
        }}
        onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
        onMouseLeave={(e) => (e.target.style.background = "#E53935")}
        onClick={() => {
          setFilters({ municipality_id: "", district_id: "" });
          setPage(1);
          setPerPage(10);
          fetchClfListReport(1, "", "");
        }}
      >
        <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
      </Button>

                  </Col>
                </Row>
              </Card.Body>
            </Card>



      {/* 📄 TABLE */}
<Card className="border-0 shadow">
  {loading ? (
    <div className="loader-wrapper py-5 text-center">
      <div className="blue-spinner mb-3"></div>

      <div className="loading-line mb-2" style={{ maxWidth: "300px", margin: "0 auto" }}>
        <div className="loading-progress"></div>
      </div>

      <p className="loading-text">Please Wait... While Gathering Reports</p>
    </div>
  ) : (
    <>
      <Table bordered hover responsive striped>
        <thead>
          <tr>
            <th style={theadStyle}>SL</th>
            <th style={theadStyle}>Municipality</th>
            <th style={theadStyle}>No. of ALF</th>
            <th style={theadStyle}>ALF Names</th>
          </tr>
        </thead>
        <tbody>
          {reportList.length ? (
            reportList.map((row, i) => (
              <tr key={row.id}>
                <td className="text-center">{(page - 1) * perPage + i + 1}</td>
                <td className="text-center">{row.name}</td>
                <td className="text-center">{row.vendors_count}</td>
                <td className="text-center">
                  {row.vendors && row.vendors.length > 0 ? (
                    row.vendors.map((vendor, idx) => (
                      <div key={vendor.id}>
                        {idx + 1}. {vendor.vendors_master_name}
                      </div>
                    ))
                  ) : (
                    <span className="text-muted">No ALF</span>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center text-muted py-4">
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <nav>
            <ul className="pagination shadow-sm">
              {/* First */}
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchClfListReport(1)}>
                  «
                </button>
              </li>

              {/* Prev */}
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchClfListReport(page - 1)}>
                  ‹
                </button>
              </li>

              {/* Page Numbers */}
              {getPageNumbers().map((p) => (
                <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                  <button className="page-link" onClick={() => fetchClfListReport(p)}>
                    {p}
                  </button>
                </li>
              ))}

              {/* Next */}
              <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchClfListReport(page + 1)}>
                  ›
                </button>
              </li>

              {/* Last */}
              <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchClfListReport(totalPages)}>
                  »
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </>
  )}
</Card>





    </div>
  );
};

export default AlfListReport;
